<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{title}}
      </div>
      <div class="card-body p-0">
        <div v-for="(orderItem, index) in details"
            :key="index"
            :id="title + '-item-' + index"
            class="row py-3 border mx-0"
            :class="[
              { 'bg-light': index % 2 != 0 },
              highlightMode === 'card' && highlightedIndexes.includes(index)
                ? 'highlight-card'
                : ''
            ]"
          >
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <span class="font-weight-bold">Item: </span>
            <span v-html="orderItem.item
                ? highlightText(getItemLabel(orderItem.item), index)
                : ''"
            ></span>
          </div>
          <div class="col-xl-6 col-md-12 col-sm-6 col-12 mt-1">
            <span class="font-weight-bold">Quantidade: </span>{{orderItem.quantity}}
          </div>
          <div class="col-xl-6 col-md-12 col-sm-6 col-12 mt-xl-0 mt-md-3 mt-sm-0 mt-3">
            <div class="row justify-content-end h-100 align-items-center">
              <div v-if="orderItem.item && orderItem.item.id" class="col-xl-auto col-md-auto col-sm-auto col-auto pr-1">
                <item-details-button :item-id="orderItem.item.id" />
              </div>
              <div class="col-xl-auto col-md-6 col-sm-auto col-6 px-1">
                <b-button size="sm" @click.prevent="editItem(index)" :disabled="editIndex === index"
                  class="large-btn-100 medium-btn-100 mobile-btn-100">
                  <i class="fa fa-edit"></i> Editar
                </b-button>
              </div>
              <div class="col-xl-auto col-md-6 col-sm-auto col-6 pl-1">
                <b-button size="sm" variant="danger" @click.prevent="openDeleteModal(index)"
                  class="large-btn-100 medium-btn-100 mobile-btn-100">
                  <i class="fa fa-trash"></i> Remover
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Animation from '@/components/loaders/animation'
  import shared from '@/shared/shared'
  import ItemDetailsButton from '@/components/common/item-details-button'

  export default {
    name: 'transformation-items-card',
    components: { Animation, ItemDetailsButton },

    props: {
      title: {
        type: String,
        require
      },
      details: {
        type: Array,
        require
      },
      highlightedIndexes: {
        type: Array,
        default: () => []
      },
      highlightMode: {
        type: String,
        default: 'text' // 'card' ou 'text'
      },
      searchTerm: {
        type: String,
        default: ''
      }
    },

    watch: {
      highlightedIndexes(newVal) {
        if (!newVal || !newVal.length) return

        this.$nextTick(() => {
          const firstIndex = newVal[0]

          const safeTitle = this.title
            ? this.title.replace(/\s+/g, '').toLowerCase()
            : 'card'

          const el = document.getElementById(
            this.title + '-item-' + firstIndex
          )

          if (el) {
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }
        })
      }
    },

    data() {
      return {
        editIndex: null
      }
    },

    methods: {
      getItemLabel(item) {
        return shared.getItemLabel(item);
      },

      editItem(index) {
        this.$parent.editItem(this.details[index], index);
      },

      openDeleteModal(index) {
        this.$parent.openDeleteModal(index, this.details[index].movementType);
      },

      highlightText(text, index) {
        if (
          this.highlightMode !== 'text' ||
          !this.highlightedIndexes.includes(index) ||
          !this.searchTerm
        ) {
          return text
        }

        return shared.highlightText(text, this.searchTerm)
      }
    }
  };
</script>

<style scoped>

</style>
